import React, { useLayoutEffect, useEffect, useRef, Suspense } from "react"
import ExtraHeader from "./Components/Header/ExtraHeader"
import { Box, Skeleton } from "@mui/material"
import { observer } from "mobx-react"
import { useForm, FormProvider } from "react-hook-form"
import AppStore from "./Configs/Stores/AppStore"
import FormStore from "./Configs/Stores/FormStore"
import { HideLandingLoader } from "./Components/Common/CommonFunctions"
import { DataLayerFn, ipAPI } from "./Configs/API"
import { Header, Calculator, TalkToExpert, Disclaimer, HeroSection, QuickGuide, FAQ, Benefits } from "./Components/index"
import HowItWorks from "./Components/HowItWorks/HowItWorks"
import SavingsRequiredForEdu from "./Components/SavingsRequiredForEdu/SavingsRequiredForEdu"
import FactorsToConsider from "./Components/FactorsToConsider/FactorsToConsider"
import WhyEarlyPlanningImportant from "./Components/WhyEarlyPlanningImportant/WhyEarlyPlanningImportant"

const SkeletonStyle = {
  margin: "auto",
  maxWidth: "1100px"
}

const MobileSkeletonStyle = {
  margin: "auto",
  maxWidth: "330px"
}

const SkeletonStyleItem = {
  height: "30px",
  margin: "3px 0px"
}

const MobileSkeletonStyleItem = {
  height: "15px",
  margin: "2px 0px"
}

const SkeletonLoader = observer((props: any) => {
  const isDesktop = AppStore.device === 1
  return (
    <Box ref={props.SectionRef} sx={isDesktop ? SkeletonStyle : MobileSkeletonStyle}>
      <Skeleton sx={isDesktop ? { ...SkeletonStyleItem, width: "50%" } : { ...MobileSkeletonStyleItem, width: "50%" }} />
      <Skeleton sx={isDesktop ? SkeletonStyleItem : MobileSkeletonStyleItem} />
      <Skeleton sx={isDesktop ? SkeletonStyleItem : MobileSkeletonStyleItem} />
      <Skeleton sx={isDesktop ? SkeletonStyleItem : MobileSkeletonStyleItem} />
      <Skeleton sx={isDesktop ? SkeletonStyleItem : MobileSkeletonStyleItem} />
    </Box>
  )
})

const App = observer(() => {
  const DEFAULTS = {
    parentDOB: FormStore.calc_parentDOB,
    parentGender: FormStore.calc_parentGender,
    childName: FormStore.calc_childName,
    childGender: FormStore.calc_childGender,
    childDOB: FormStore.calc_childDOB,
    profession: FormStore.calc_profession,
    professionOther: FormStore.calc_professionOther,
    duration: FormStore.calc_duration,
    investRange: FormStore.calc_invest,
    invest: FormStore.calc_invest,
    mode: FormStore.calc_mode,
    email: FormStore.calc_email,
    income: FormStore.calc_income,
    mobile: FormStore.calc_mobile,
    ndncCB: FormStore.calc_NDNC
  }

  const HookForm = useForm({
    defaultValues: DEFAULTS,
    mode: "onChange"
  })

  useLayoutEffect(() => {
    DataLayerFn("Landed||Calculator-Landing page", FormStore, "", "", "", "")
    const handleResize = () => {
      const width = window.innerWidth
      AppStore.setWindowWidth(width)
      if (width < 1020.5) {
        AppStore.setDevice(0)
      } else {
        AppStore.setDevice(1)
      }
      if (!AppStore.isDepTesting && !AppStore.isLocalHost) {
        console.log = () => {}
        console.info = () => {}
      }
      console.log(`Device=${AppStore.device === 0 ? "Mobile" : "PC"}, State=${AppStore.device}, Width=${width}}`)
    }

    handleResize()
    window.addEventListener("resize", handleResize, { passive: true })
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (AppStore.appLoaded) {
      var EmptyScript = window.scriptsLoaded
      var isResume = AppStore.isResumeJourney
      var isStepTrue = new URL(window.location.href).searchParams.get("Step") === "true"

      if (!EmptyScript) {
        const collectIp = async () => {
          const ip = await ipAPI()
          // const ip = { origin: "abc" }
          // console.info("IP :", ip)
          AppStore.setIpAddress(ip["origin"])
          window.ipAddress = ip["origin"]
          localStorage.recent_product = "ChildEduPlanner_dynamic"
        }
        if (!isStepTrue) {
          setTimeout(HideLandingLoader, isResume ? 2500 : 1000)
        }
        collectIp()

        window.scriptsLoaded = true
      }
    }
  }, [AppStore.appLoaded])

  return (
    <>
      <ExtraHeader />
      <Header />
      <TalkToExpert />
      <HeroSection />
      <FormProvider {...HookForm}>
        <Calculator />
      </FormProvider>
      <HowItWorks />

      <QuickGuide />
      <Benefits />
      <SavingsRequiredForEdu />
      <FactorsToConsider />
      <WhyEarlyPlanningImportant />
      <FAQ />
      <Disclaimer place="main" />
    </>
  )
})
export default App
